import Axios from "axios"
import siteConfigs from "../constants/StieConfigs"

export async function emailQuestions(data){
    console.log('data',data)
    let res = await Axios.post(`${siteConfigs.apiEndPoint}email/questions`, data)
    return res
}